import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse, HttpXhrBackend } from "@angular/common/http";
import { BehaviorSubject, Subject, Observable, of } from 'rxjs';
import { map, switchMap, catchError, mergeMap, tap, retry } from 'rxjs/operators';
import { LocalDataSource } from 'ng2-smart-table';

//import { MessageService } from './message.service';


// import { Observable } from 'rxjs/Observable';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/observable/of';
// import 'rxjs/add/observable/empty';
// import 'rxjs/add/operator/retry'; // don't forget the imports
import Swal from 'sweetalert2';

import { environment } from '../../environments/environment'
import { Anexo } from './insti.component';
import { instiUser } from './instiUser.module'; 
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class InstiService {
  private baseUrl: string = environment.base_url_api;
//  private baseUrl: string = 'http://api.gestaoCondominio.local/';
  private headers: Headers = new Headers({'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': 'http://localhost:4200'
  });
   private csr_token: string = ''; 
   private session_name:string ='';
   private session_id: string ='';
   private session_obj: any={};
   private authorization: string = '';
   private page_base_url='';
   private user_data:any=null;
   private user:instiUser;

  // const httpClient = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest()}));

   
   
  getUrl(sufix){
      var token=sufix=='csr-xtoken'? '' : this.tokenOnUrl();
      return !sufix ? this.baseUrl+token : this.baseUrl+sufix+token;
  } 
  getUrlWithoutToken(sufix){
      return !sufix ? this.baseUrl : this.baseUrl+sufix;
  }
  private csr_xtoken: string = ''; 
  // =new HttpClient();
  //private httpClient: HttpClient,
  //  public message : MessageService           
  
    protected http: HttpClient
    // protected router: Router
  constructor(
         
            ) {
                this.initUser();
            }
  
    private setCsrXtoken(){
        
    } 
    private  setCsrToken(value){ this.csr_token=value._token; }  
    private  setSessionObj(value){
            this.session_name=value.session_name;
            this.session_id=value.session_id;
            this.session_obj[this.session_name]=this.session_id;
    }
 

    // private setUserData(value):InstiService{ //Comentei para conseguir setar nullo no init do login.component   

  getCsrXtoken(){ return this.csr_xtoken;}  
  loadCsrToken(){
          var instance=this;
        var a=this.http.get(instance.getUrl('csr-xtoken'));
        a.subscribe(function(response){
                    instance.setCsrToken(response);
                    instance.setSessionObj(response);
                }, 
                function(error){
                    /**
                     * @TODO ALUISIO FERREIRA DE SOUSA 05/09/2019
                     *  Adicionar um HANDLE de erro
                     */
                    var b=error;
                });        
       return a;          
    }
     getSessionObj(){ return this.session_obj;}
     getCsrToken(){ return this.csr_token; }

     hasCsrToken(){ return this.csr_token==''? false : true; }
     getHeadersAsArray(){
        
          var retorno={'X-CSRF-TOKEN':this.getCsrToken(),
                      'Authorization': 'Bearer '+this.getUser().getAuthorization(),
                      'Content-Type': 'application/json; charset=utf-8',
                      'InstCli': JSON.stringify(this.getClientInformation())
                      };
                      
            if(this.session_name && this.session_name!=''){
                retorno[this.session_name]=this.session_id;
            }            
          return retorno;          
     }

     //  headerInTerpolation(headersInstance, properties?){
    //      var headers=headersInstance;//headersInstance.clone();
    //      var prop=!properties ? this.getHeadersAsArray() : properties;
    //       var keys=Object.keys(prop);
    //      for(var x=0; x< keys.length; x++){
    //          var chave=keys[x];
    //          if(chave==''){ continue; }
    //         headers=headers.set(chave, prop[chave]);
    //      }
    //      return headers;                  
    //  }
    //  getHeaders(){  
    //      var retorno=this.getHeadersAsArray();          
    //      this.headers=this.headerInTerpolation(new HttpHeaders());
    //      return {'headers':  this.headers};
    //       //{headers: this.headers};  
    //  }
    headerInTerpolation(headersInstance, properties?){
        var headers=headersInstance;
       var prop=!properties ? this.getHeadersAsArray() : properties;
        var keys=Object.keys(prop);
       for(var x=0; x< keys.length; x++){
           var chave=keys[x];
           if(chave==''){ continue; }
          headers=headers.append(chave, prop[chave]);
       }
       return headers;  
       /*
       var headers=headersInstance;//headersInstance.clone();
       var prop=!properties ? this.getHeadersAsArray() : properties;
        var keys=Object.keys(prop);
       for(var x=0; x< keys.length; x++){
           var chave=keys[x];
           if(chave==''){ continue; }
          headers=headers.set(chave, prop[chave]);
       }
       return headers;
       */                  
   }

    //  getHeaders(){        
    //       var retorno=this.getHeadersAsArray();          
    //      this.headers= this.headerInTerpolation(new HttpHeaders());
    //      return {'headers':  this.headers};//{headers: this.headers};
    //  }

    getHeaders(){  
        let retorno=this.headerInTerpolation(new HttpHeaders());;          
         this.headers=retorno;
         return {'headers':  retorno};
     }

     getClientInformation(){
        var ci=clientInformation;
        var fields=['appCodeName','appName', 'appVersion','language',
                    'plataform','product','productSub','userAgent'];
        var retorno={};
        for(var x=0; x < fields.length; x++){
            var atual=fields[x];
            /*if(ci.hasOwnProperty(atual)===false){
                continue;
            } */           
            retorno[atual]=ci[atual];
        }
        return retorno;            
     }


     appendToken(dados){
         dados._token=this.getCsrToken();
         return dados; 
     }  
     tokenOnUrl(){  return '?token='+this.getCsrToken();} 
     setPageUrlBase(url:string){
         this.page_base_url=url;
     }
     getPageUrlBase(){ return this.page_base_url;}
     getPageUrlFull(){ return this.getUrl(this.getPageUrlBase());}
     getPageUrlList(){ return this.getPageUrlBase()+'listar'}
     getPageUrlGetAll(){ return this.getPageUrlBase()+'listar'}
     getPageUrlAdd(){ return this.getPageUrlBase()+'insert'}
     getPageUrlUpdate(){ return this.getPageUrlBase()+'update'}
     getPageUrlDel(){ return this.getPageUrlBase()+'delete'}
     getPageUrlFilter(){ return this.getPageUrlBase()+'filter'}
     getHomeUrl(with_prefix?){ return (with_prefix===true? '/': '')+environment.home_route;}
     getLoginUrl(with_prefix?){ return (with_prefix===true? '/': '')+environment.login_route;}
     getLogoutUrl(with_prefix?){ return (with_prefix===true? '/': '')+environment.logout_route;}
    

     /***
      * @TODO ALUISIO FERREIRA DE SOUSA 09/09/2019
      * No momento estou considerando apenas os metodos GET e POST
      * @param url_sufix string Obrigatorio
      * @param metodo STRING Obrigatorio, valroes aceitos get, post
      * @param success_call_back FUNCTION Opcional função de callback quando ok,
      * @param error_call_back FUNCTION opcional função de callback quando tem erro.
      * @param form_data Object opcional dados a serem enviados ao servidor
      *  @param model 
      */
     doHttp(url_sufix:string, metodo:string, success_call_back?, error_call_back?, form_data?, model?, is_external?){
        
        // let excessoes = ['login', 'empresa-filial'];


        // console.log("caaaaaaaaaaaaaaaaaaaaaaaa", this.router.url);
        // if(!localStorage.getItem("empsSelecionadas") && !excessoes.includes(this.router.url)){

        //     this.showAlert("Atenção!", 'Selecione uma empresa/filial para continuar!', 'warning');
        //     if((typeof error_call_back ==='function')){
        //         error_call_back({msg:'Selecione uma empresa/filial para continuar!',status:'error'})
        //     } 

        //     this.router.navigate(['gestao-condominio/empresa-filial']);
        //     return this;
        // }
        // console.log('testeeeeeeeeeeeeeeee', form_data);
        var empresasId = JSON.parse(localStorage.getItem("empSelecionadas"));
        var strId = '?emps=';
        var strGrupId = 'grups='
        var strFilId = 'filiais=' 
            console.log(empresasId);
        if(empresasId){
            for (const empId of empresasId) {
                if(strId != '?emps='){
                    strId +=  ',';
                }
                strId +=  empId['empresa_id'] ;  
                if(metodo === 'post'){
                    form_data['empresa_id'] = empId['empresa_id'];
                    form_data['grupo_id'] = empId['grupo_id'];
                    form_data['filial_id'] = empId['filial_id'];
                }    
            }
            for (const empId of empresasId) {
                if(strGrupId != 'grups='){
                    strGrupId +=  ',';
                }
                strGrupId +=  empId.grupo_id ;  
            }
            for (const empId of empresasId) {
                if(strFilId != 'filiais='){
                    strFilId +=  ',';
                }
                strFilId +=  empId.filial_id ;  
            }
        }
        // console.log("strID", strId);
        
        url_sufix += strId + '&' + strGrupId + '&' + strFilId + '&';

        // console.log('urlSufix', url_sufix);

        var instance=this;        
            var obj_model=!model? {} : model;
            var erro_call="";
            var method_name=["get", "post"].indexOf(metodo)<0? "get": metodo;
            var form_data_get = {filiais: 'empSelecionadas'};
            var url=is_external===true ? url_sufix : instance.getUrl(url_sufix)
            var methodType={'get':function(){ return instance.http.get(url,  instance.getHeaders()); },
                            'post':function(){ return instance.http.post(url, form_data, instance.getHeaders());}
                            };                            
                            // console.log('instance.getHeaders()', instance.getHeaders());
 
            var http_objt=methodType[method_name]();

            http_objt.subscribe(
                (response)=>{
                    return (typeof success_call_back !=='function') ? null : success_call_back(response)
                },
                (error)=>{
                   return (typeof error_call_back !=='function') ? null: error_call_back(error)
                });                
                
            return http_objt.pipe(
                  //retry(1),
                  // tap((newCargo: Cargo) => this.log(`added login w/ ${newCargo}`)),
                  catchError(function(error){
                       return (typeof error_call_back !=='function') ? null: error_call_back(error);
                  })
                );
     }
     /**
      * matrix_retorno ARRAY Obrigatorio
      * sucess_func FUNCTION opcional
      * error_func FUNCTION opcional
      */
     getAll(sucess_func?, error_func?){ 
        var call_error=(typeof error_func !=='function') ? function(error){
            console.log('Atenção! JS260920191742.');
        }: error_func; 
        var call_success=function(response){
            return (typeof sucess_func !=='function') ?  null :  sucess_func(response);

        } 
       var instance=this; 
       return this.doHttp(instance.getPageUrlGetAll(), 'get', call_success, call_error, null, null);
    }

      listar(matrix_retorno, sucess_func?, error_func?){
         var call_error=(typeof error_func !=='function') ? function(error){
             console.log('Atenção! JS090920191616.');
         }: error_func; 
         var call_success=function(response){
             
             matrix_retorno.load(response);
            return (typeof sucess_func !=='function') ?  null :  sucess_func(response);
         } 
        var instance=this; 
        return this.doHttp(instance.getPageUrlList(), 'get', call_success, call_error, null, null);
     }
     adicionar(form_data, sucess_func?, error_func?){
         var call_error=(typeof error_func !=='function')? function(error){
             console.log('Atenção! JS090920191622.');
         }: error_func; 
         var call_success=function(response){
            return (typeof sucess_func !=='function') ?  null : sucess_func(response);
         } 
        var instance=this; 
        return this.doHttp(instance.getPageUrlAdd(), 'post', call_success, call_error, form_data, null);
     }
     editar(form_data, sucess_func?, error_func?){ 
         var call_error=(typeof error_func !=='function')? function(error){
             console.log('Atenção! JS090920191632.');
         }: error_func; 
         var call_success=function(response){
            return (typeof sucess_func !=='function') ?  null : sucess_func(response);
         } 
        var instance=this; 
        return this.doHttp(instance.getPageUrlUpdate(), 'post', call_success, call_error, form_data, null);
     }
     deletar(form_data, sucess_func?, error_func?){
         var call_error=(typeof error_func !=='function')? function(error){
             console.log('Atenção! JS090920191636.');
         }: error_func; 
         var call_success=function(response){
            return (typeof sucess_func !=='function') ?  null : sucess_func(response);
         } 
        var instance=this; 
        return this.doHttp(instance.getPageUrlDel(), 'post', call_success, call_error, form_data, null);
     }

    logar(dados, sucess_func?, erro_func?){
        var instance=this;
        this.getUser().setData(null);
        this.doHttp('logar','post',
            function(response){
                return instance.getUser().setData(response.hasOwnProperty('dados')? response.dados : null, response, sucess_func);                    
                // (typeof sucess_func !=='function') ?  null : sucess_func(response);
            }, 
            //    function(response){
            //        instance.getUser().setData(response.hasOwnProperty('dados')? response.dados : null);                    
            //        return (typeof sucess_func !=='function') ?  null : sucess_func(response);
            //    }, 
               function(error){
                  return (typeof erro_func !=='function') ?  null : erro_func(error);
               }, 
               dados);
    }
    logout(){
        var instance=this;
        this.doHttp('logout','post',function(response){
             instance.getUser().setData(null);
             
        },function(error){
            instance.getUser().setData(null);
       });          
    }
    showAlert(titulo, mensagem, tipo, showCancel=false,call_back?){
       Swal.fire({ 
         title: titulo,
         html:mensagem,
         type: tipo,
         showCancelButton: showCancel,
         showConfirmButton: true,
       }).then(call_back);  
     }


    ajusteURL(){
       if(this.getPageUrlBase().indexOf('/')>-1){
           return this.getPageUrlBase().substr(0, this.getPageUrlBase().length-1)
       }

       return this.getPageUrlBase();
    }
    getUrlPrint(){
        return environment.print_route;
    }

    getUrlExport(){
        return environment.export_route;
    }
    
    initUser(){
        this.user=new instiUser();
        return this;
    }
    getUser(){ return this.user? this.user: this.initUser().user; }

    filter(params, sucess_func?, error_func?){
        var call_error=(typeof error_func !=='function') ? function(error){
            console.log('Atenção! JS130320200930.');
        }: error_func; 
        var call_success=function(response){
            return (typeof sucess_func !=='function') ?  null :  sucess_func(response);
        } 
        var instance=this; 
        return this.doHttp(instance.getPageUrlFilter(), 'post', call_success, call_error, params, null);
    }
    /*
     * ALUISIO FERREIRA DE SOUSA 17/02/2020
     * @TODO Metodos que estao na classe de usuarios pois estao comentados
     * 
    private processDataUser(dados):InstiService{
        if(!this.hasUserData()){ return   this.setAuthorization(null); }
        var ud=dados;
        this.setAuthorization(ud.hasOwnProperty('api_authorizations')? ud.api_authorizations : null);      
    }
    private setAuthorization(value):InstiService{ 
        this.authorization=value; 
        localStorage.setItem('insti_authorization', value);
        return this;
      }
      getAuthorization(){ 
        var b=this.authorization ? this.authorization : this.getAutorizationFromStorage();
        try {
            return (JSON.parse(b)) ? b : '';
        } catch (error) {
        }
        return b;
    } 
     getAutorizationFromStorage(){
        var a=localStorage.getItem('insti_authorization');
        return a;
    }
    setUserData(value):InstiService{ 
        var d=!value ? {} : value;
        this.user_data=Object.keys(d).length==0? null : (d.hasOwnProperty('user_data') ? d.user_data : null);
        localStorage.setItem('insti_user_data', JSON.stringify(this.user_data)); 
        return this.getUser().processDataUser(d);
    }
      setAlterarSenhaUser(value){
        let user = {};
        user['user_data'] = this.getUserData();
        user['user_data'].alterarSenha = value;
        user['api_authorizations'] = this.getUser().getAuthorization();
        this.getUser().setUserData(user);
    }   
    getUserDataFromStorage(){
        var a=JSON.parse(localStorage.getItem('insti_user_data')); 
        return a;
     }
     getUserData(){ 
        var c= this.user_data ? this.user_data : this.getUserDataFromStorage() ;
        return c;
    }
    hasUserData():boolean{
        let d=this.getUserData(); 
        if(!d){ return false;}
        return Object.keys(d).length==0? false : true;
    }
    userAlterarSenha():boolean{
        let d=this.getUser().getUserData();
        if(!d){ return false;}
        if(!d.hasOwnProperty('alterarSenha')){            
            return false;
        }
        return d.alterarSenha == 1 ? true : false;
    }
      isLogged():boolean{ return this.hasUserData();}
    *
    *
    */
    
   getUserDataFromStorage(){
        var a=JSON.parse(localStorage.getItem('insti_user_data')); 
        return a;
   }
   getUserData(){ 
        var c= this.user_data ? this.user_data : this.getUserDataFromStorage() ;
        return c;
   }
   hasUserData():boolean{
        let d=this.getUserData(); 
        if(!d){ return false;}
        return Object.keys(d).length==0? false : true;
   }
        
    
    
    
    

//      getUrlAnexo(id:any, sucess_func?, error_func?): Promise<String> {
   
//             var call_error=(typeof error_func !=='function')? function(error){
//             }: error_func; 
//             var call_success=function(response){
//                return (typeof sucess_func !=='function') ?  null : sucess_func(response);
//             } 
//            var instance=this; 
//            return this.doHttp(this.baseUrl+'/getUrlAnexos/'+id, 'get', call_success, call_error, null, null);
      
//     }
    
//       getAnexos(id:any, sucess_func?, error_func?): Promise<Anexo[]> {

//         var call_error=(typeof error_func !=='function')? function(error){
//         }: error_func; 
//         var call_success=function(response){
//            return (typeof sucess_func !=='function') ?  null : sucess_func(response);
//         }           
//        return this.doHttp(this.baseUrl+'/getAnexos/'+id, 'get', call_success, call_error, null, null);
//     }
}

